export default {
  orderLineConfirmed: {
    id: 'bo_sellers-orders-components-orders_table-actions-order_line_confirmed',
    defaultMessage: 'Orderline {orderLineId} confirmed',
  },
} as const
